/*
 * app.js
 * Copyright (C) 2017 tiglog <xq@tiglog.com>
 *
 * Distributed under terms of the MIT license.
 */
$(function () {
    // Pace.options = {
    //     elements: {
    //         selectors: ['#page']
    //     }
    // };
    $("body")
        .on("click", "input.checkbox-ctrl", function (e) {
            var self = $(this),
                ctrlselector = self.data("ctrl"),
                $items = $(ctrlselector);
            if ($items.length === 0) {
                return;
            }
            if (self.is(":checked")) {
                $items.prop("checked", true);
            } else {
                $items.prop("checked", false);
            }
        })
        .on("click", "a.btn-batch-op", function (e) {
            // console.log("click link");
            e.preventDefault();
            var self = $(this),
                params = self.data(),
                url = self.prop("href");
            //delete params['ctrl'];
            var ctrlselector = self.data("ctrl");
            if (!ctrlselector) {
                return false;
            }
            var $items = $(ctrlselector).filter(":checked");
            if ($items.length === 0) {
                layer.msg("至少需要选择一个条目");
                return false;
            }

            var handleClick = function () {
                params["_csrf"] = $('meta[name="csrf-token"]').attr("content");
                var _vals = [];
                $items.each(function (idx) {
                    var that = $(this);
                    if (that.is(":checked")) {
                        _vals.push(that.val());
                    }
                });
                params[$items.first().prop("name")] = _vals;
                var loading = layer.load();
                $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "json",
                    data: params,
                })
                    .done(function (res) {
                        if (res.stat == "ok") {
                            layer.msg(res.msg || "成功");
                            setTimeout(function () {
                                location.reload();
                            }, 2000);
                        } else {
                            layer.msg(res.msg || "失败");
                        }
                    })
                    .fail(function (_, __, err) {
                        layer.msg(err || "失败");
                    })
                    .always(function () {
                        layer.close(loading);
                    });
            };
            var confirm = self.data("confirmx");
            if (confirm) {
                layer.confirm(
                    confirm,
                    { icon: 3, title: "提示" },
                    function (idx) {
                        layer.close(idx);
                        handleClick();
                    }
                );
            } else {
                handleClick();
            }
            return false;
        })
        .on("click", "a.btn-view", function (e) {
            e.preventDefault();
            var self = $(this),
                params = self.data(),
                url = self.prop("href");
            var ctrlselector = self.data("ctrl");
            if (!ctrlselector) {
                return false;
            }
            var $items = $(ctrlselector).filter(":checked");
            if ($items.length === 0) {
                layer.msg("至少需要选择一个条目");
                return false;
            }
            params["_csrf"] = $('meta[name="csrf-token"]').attr("content");
            var _vals = [];
            $items.each(function (idx) {
                var that = $(this);
                if (that.is(":checked")) {
                    _vals.push(that.val());
                }
            });
            if (_vals.length === 0) {
                layer.alert("请至少选择一个条目");
                return false;
            }
            params[$items.first().prop("name")] = _vals;
            var loading = layer.load();
            $.ajax({
                url: url,
                type: "POST",
                dataType: "html",
                data: params,
            })
                .done(function (res) {
                    layer.open({
                        title: self.prop("title") || self.text(),
                        content: res,
                        area: "800px",
                    });
                })
                .fail(function (_, __, err) {
                    layer.msg(err || "失败");
                })
                .always(function () {
                    layer.close(loading);
                });

            return false;
        });
});
